import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import './MyProfilePage.css';

const host = process.env.REACT_APP_API_HOST; // API 地址

const cryptoKey = process.env.REACT_APP_CRYPTO_KEY; // 确保与生成令牌时的密钥一致



function MyProfilePage() {
    const [activeTab, setActiveTab] = useState('view'); // 当前选中的菜单项
    const [userInfo, setUserInfo] = useState(() => {
        // 从 localStorage 中获取用户信息
        return JSON.parse(localStorage.getItem('userInfo'));
    });
    const [newUserInfo, setNewUserInfo] = useState(userInfo);
    const [chgPwd, setChgPwd] = useState({
        password: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false); // 控制当前密码显示/隐藏
    const [showNewPassword, setShowNewPassword] = useState(false); // 控制新密码显示/隐藏
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // 控制确认密码显示/隐藏
    

    const handleUpdateProfile = () => {

        if (!newUserInfo.user_name || !newUserInfo.user_email) {
            alert('姓名和邮箱不能为空！');
            return;
        } else if (!/\S+@\S+\.\S+/.test(newUserInfo.user_email)) {
            alert('请输入有效的邮箱地址！');
            return;
        } else if (newUserInfo.user_name.length < 2 || newUserInfo.user_name.length > 10) {
            alert('姓名长度必须在 2 到 10 个字符之间！');
            return;
        } else if (newUserInfo.user_name === userInfo.user_name && newUserInfo.user_email === userInfo.user_email) {
            alert('没有任何更改！');
            return;
        }

        const userId = userInfo.user_id;
        const token = localStorage.getItem('token');
        axios
            .put(
                `${host}/api/admin/users/${userId}`,
                { name: newUserInfo.user_name, email: newUserInfo.user_email },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(() => {
                alert('个人信息更新成功！');
                setUserInfo(newUserInfo);
                localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
                            })
            .catch((err) => {
                console.error('Failed to update profile:', err.response?.data?.error || err);
                alert('更新失败，请稍后重试。');
            });
    };

    const handleChangePassword = async () => {
        const { password, newPassword, confirmPassword } = chgPwd;

        const encryptedNewPassword = CryptoJS.AES.encrypt(newPassword, cryptoKey).toString();
        const encryptedPassword = CryptoJS.AES.encrypt(password, cryptoKey).toString();
        const token = localStorage.getItem('token');
        const userId = userInfo.user_id;
        
        if (!password || !newPassword || !confirmPassword) {
            alert('所有字段都是必填的！');
            return;
        } else if (password.length < 6 || newPassword.length < 6 || confirmPassword.length < 6) {
            alert('密码长度必须至少为 6 个字符！');
            return;
        } else if (password === newPassword) {
            alert('新密码不能与当前密码相同！');
            return;
        } else if (newPassword !== confirmPassword) {
            alert('新密码和确认密码不一致！');
            return;
        } 

    
        axios
            .put(
                `${host}/api/admin/users/${userId}/change_password`,
                { password: encryptedPassword, newPassword: encryptedNewPassword },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(() => {
                alert('密码修改成功！');
                
                // 清空密码输入框
                setChgPwd({ password: '', newPassword: '', confirmPassword: '' })

            })
            .catch((err) => {
                console.error('Failed to change password:', err.response?.data?.error || err);
                alert(`密码修改失败，请稍后重试。:${err.response?.data?.error || err}`,);
            });
    };

    return (
        <div className="profile-container">
            <div className="profile-sidebar">
                <ul>
                    <li
                        className={activeTab === 'view' ? 'active' : ''}
                        onClick={() => setActiveTab('view')}
                    >
                        查看我的信息
                    </li>
                    <li
                        className={activeTab === 'edit' ? 'active' : ''}
                        onClick={() => setActiveTab('edit')}
                    >
                        修改我的信息
                    </li>
                    <li
                        className={activeTab === 'password' ? 'active' : ''}
                        onClick={() => setActiveTab('password')}
                    >
                        修改密码
                    </li>
                </ul>
            </div>
            <div className="profile-content">
                {activeTab === 'view' && (
                    <div className="myprofile">
                        <h1>我的信息</h1>
                        <p>用户名: {userInfo.username}</p>
                        <p>姓名: {userInfo.user_name}</p>
                        <p>邮箱: {userInfo.user_email}</p>
                    </div>
                )}
                {activeTab === 'edit' && (
                    <form onSubmit={(e) => { e.preventDefault(); handleUpdateProfile(); }}>
                        <h1>修改我的信息</h1>
                        <div className="form-group">
                            <label>姓名:</label>
                            <input
                                type="text"
                                value={newUserInfo.user_name}
                                onChange={(e) => setNewUserInfo({ ...newUserInfo, user_name: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label>邮箱:</label>
                            <input
                                type="email"
                                value={newUserInfo.user_email}
                                onChange={(e) => setNewUserInfo({ ...newUserInfo, user_email: e.target.value })}
                            />
                        </div>
                        <button type="submit">更新信息</button>
                    </form>
                )}
                {activeTab === 'password' && (
                    <form onSubmit={(e) => { e.preventDefault(); handleChangePassword(); }}>
                        <h1>修改密码</h1>
                        <div className="form-group">
                            <label>当前密码:</label>
<div className="password-input">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={chgPwd.password}
                                onChange={(e) => setChgPwd({ ...chgPwd, password: e.target.value })}
                            />
<span
                                    className={`password-toggle ${showPassword ? 'show' : ''}`}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? '🔓' : '🔒'}
                                </span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>新密码:</label>
<div className="password-input">
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                value={chgPwd.newPassword}
                                onChange={(e) => setChgPwd({ ...chgPwd, newPassword: e.target.value })}
                            />
<span
                                    className={`password-toggle ${showNewPassword ? 'show' : ''}`}
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                >
                                    {showNewPassword ? '🔓' : '🔒'}
                                </span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>确认新密码:</label>
<div className="password-input">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={chgPwd.confirmPassword}
                                onChange={(e) => setChgPwd({ ...chgPwd, confirmPassword: e.target.value })}
                            />
<span
                                    className={`password-toggle ${showConfirmPassword ? 'show' : ''}`}
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                    {showConfirmPassword ? '🔓' : '🔒'}
                                </span>
                            </div>
                        </div>
                        <button type="submit">修改密码</button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default MyProfilePage;